/**
 * Utility functions for AI action error classification
 */

import axios from 'axios'
import { ErrorType, WORKFLOW_CONSTANTS } from '../../models/aiAnalysis/workflow'

export interface ClassifiedError {
  message: string
  type: ErrorType
}

interface AiActionErrorResponseData {
  current_decision?: string
}

export const classifyAiActionError = (err: unknown, retryCount: number): ClassifiedError => {
  if (!axios.isAxiosError<AiActionErrorResponseData>(err) || !err.response) {
    if (retryCount >= WORKFLOW_CONSTANTS.MAX_RETRY_ATTEMPTS) {
      return {
        message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_FATAL,
        type: ErrorType.FATAL
      }
    }
    return {
      message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_RETRYABLE,
      type: ErrorType.RETRYABLE
    }
  }

  const status = err.response.status

  // 422 with current_decision = already decided by another user
  if (status === 422 && err.response.data?.current_decision) {
    return {
      message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_ALREADY_DECIDED,
      type: ErrorType.ALREADY_DECIDED
    }
  }

  if (status === 404 || status === 403 || status === 401) {
    return {
      message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_FATAL,
      type: ErrorType.FATAL
    }
  }

  if (retryCount >= WORKFLOW_CONSTANTS.MAX_RETRY_ATTEMPTS) {
    return {
      message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_FATAL,
      type: ErrorType.FATAL
    }
  }

  return {
    message: WORKFLOW_CONSTANTS.ERROR_MESSAGE_RETRYABLE,
    type: ErrorType.RETRYABLE
  }
}

export const shouldCloseOnDismiss = (errorType: ErrorType | null): boolean => {
  return errorType === ErrorType.ALREADY_DECIDED || errorType === ErrorType.FATAL
}
